import Vue from "vue";
import VueI18n from "vue-i18n";
import AppConfigClass from "./include/config";

let config = new AppConfigClass();



Vue.use(VueI18n);
const locales = require.context(
  "./locales",
  true,
  /[A-Za-z0-9-_,\s]+\.json$/i
);

function loadLocaleMessages() {

  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

function localeNames() {
    const filenames = locales.keys();
    /*The forthcoming can be modified in case we want to extract more than the language.
    I.e., at the moment, if we have an en-GB.json in locales, it will extract the en.
    However, if there are two versions of English (e.g. en-US) we might need to extract more. */

    const localeLangs =filenames.map(filename => {
    const start = filename.lastIndexOf('/') + 1; // Get the index after the last '/'
    const end = filename.lastIndexOf('-'); // Get the index before the '-'
    return filename.substring(start, end);
    });

    return localeLangs;

}

const dateTimeFormatDefaults = {
  'euro': {
    date: {
      year: 'numeric', month: 'long', day: 'numeric'
    },
    time: {
      hour: 'numeric', minute: 'numeric', hour12: false
    },
    timeWithSeconds: {
      hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: false
    },
    datetime: {
     	year: 'numeric', month: 'short', day: 'numeric' ,
    	hour: 'numeric', minute: 'numeric', hour12: false
    },
    monthyear: {
     	year: 'numeric', month: 'short'
    }
  },
  'us': {
    date: {
      year: 'numeric', month: 'short', day: 'numeric'
    },
    time: {
      hour: 'numeric', minute: 'numeric'
    },
    timeWithSeconds: {
      hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: false
    },
    datetime: {
     	year: 'numeric', month: 'short', day: 'numeric' ,
    	hour: 'numeric', minute: 'numeric', hour12: true
    },
    monthyear: {
     	year: 'numeric', month: 'short'
    }
  }
}

const dateTimeFormats = Object.fromEntries(
  localeNames().map(name => [name, dateTimeFormatDefaults.euro])
);
// Write in exceptions here
dateTimeFormats['en-US'] = dateTimeFormatDefaults.us

const i18n = new VueI18n({
    locale: null,
    fallbackLocale: 'no-TR',
    messages: loadLocaleMessages(),
    dateTimeFormats
  });

  async function applyTranslationOverrides() {
    try {
        const overrides = config.getValue('languageoverride');
        
       
        if (!overrides || typeof overrides !== 'object') {
          console.warn('No valid overrides found');
          return;
        }
    
        Object.entries(overrides).forEach(([locale, localeOverrides]) => {
          if (!i18n.availableLocales.includes(locale)) {
            console.warn(`Locale "${locale}" not available - skipping`);
            return;
          }
    
          const currentMessages = i18n.getLocaleMessage(locale) || {};
          let hasChanges = false;
    
          const newMessages = { ...currentMessages };
    
          // Apply all overrides for this locale
          Object.entries(localeOverrides).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
              newMessages[key] = value;
              hasChanges = true;
              //console.log(`Overriding "${locale}.${key}"`);
            }
          });
    
          if (hasChanges) {
            i18n.setLocaleMessage(locale, newMessages);
            //console.log(`Updated ${locale} with ${Object.keys(localeOverrides).length} overrides`);
          }
        });
    
      } catch (error) {
        console.error('Failed to apply translation overrides:', error);
      }
  }

applyTranslationOverrides()

export default i18n;
